import React from 'react';
import { motion } from 'framer-motion';
import { Check, Layers, FileText, Calendar, Users, Activity, Target } from 'lucide-react';
export function ProductOverview() {
  const levels = ['Principiante', 'Intermedio', 'Avanzado', 'Categorías Formativas', 'Adultas', 'Alto Rendimiento', 'Amateur'];
  const features = [{
    icon: <FileText className="w-5 h-5" data-id="element-286" />,
    text: '+300 páginas de contenido estructurado'
  }, {
    icon: <Calendar className="w-5 h-5" data-id="element-287" />,
    text: '+60 sesiones completas listas para dar'
  }, {
    icon: <Activity className="w-5 h-5" data-id="element-288" />,
    text: 'Fisiología · Planificación · Físico · Táctica · Sesiones · Liderazgo'
  }, {
    icon: <Target className="w-5 h-5" data-id="element-289" />,
    text: 'Funciona desde el primer día en tu club o academia'
  }];
  return <section className="py-10 md:py-20 px-4 bg-navy text-white" data-id="element-290">
      <div className="max-w-5xl mx-auto" data-id="element-291">
        <div className="text-center mb-8 md:mb-16" data-id="element-292">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-block bg-brandGreen/20 text-brandGreen font-bold px-4 py-2 rounded-full mb-4 md:mb-6 text-xs md:text-base tracking-wide" data-id="element-293">
            SISTEMA N°1 PARA ENTRENADORES DE FÚTBOL FEMENINO EN ARGENTINA
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-5xl font-black mb-4 md:mb-6" data-id="element-294">
            MEGAPACK — SISTEMA COMPLETO
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg md:text-2xl text-gray-300 font-medium" data-id="element-295">
            6 Tomos + 6 Bonos — Todos los niveles — Toda la temporada resuelta.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 items-center mb-8 md:mb-16" data-id="element-296">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-4 md:space-y-6" data-id="element-297">
            {features.map((feature, index) => <div key={index} className="flex items-center gap-3 md:gap-4 bg-navy-light p-3 md:p-4 rounded-xl border border-white/10" data-id="element-298">
                <div className="bg-brandGreen/20 p-2 md:p-3 rounded-lg text-brandGreen" data-id="element-299">
                  {feature.icon}
                </div>
                <p className="text-base md:text-lg font-semibold" data-id="element-300">
                  {feature.text}
                </p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-light p-6 md:p-8 rounded-2xl border border-brandGreen/30 relative overflow-hidden" data-id="element-301">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brandGreen/10 blur-3xl rounded-full" data-id="element-302"></div>
            <h3 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 flex items-center gap-2" data-id="element-303">
              <Layers className="text-brandGreen" data-id="element-304" />
              NIVELES Y ENFOQUES INCLUIDOS:
            </h3>
            <div className="flex flex-wrap gap-2 md:gap-3" data-id="element-305">
              {levels.map((level, index) => <span key={index} className="bg-navy-dark border border-white/20 px-3 py-1.5 md:px-4 md:py-2 rounded-lg text-xs md:text-sm font-medium flex items-center gap-2" data-id="element-306">
                  <Check className="w-3 h-3 md:w-4 md:h-4 text-brandGreen" data-id="element-307" />
                  {level}
                </span>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}